<template>
    <section class="content">
        <div class="container-fluid">
            <solicitacao-boleto :solicitacao="solicitacao"></solicitacao-boleto>
        </div>
    </section>
</template>

<script>
import solicitacaoBoleto from "../comuns/solicitacaoBoleto";
import axios from "axios"; // Cliente para requisição http
export default {
    data: () => ({
        solicitacao: {
            created_at: "",
			id: "",
			paciente: {
				nome: ""
			},
            itens: [
                {
                    contrato_procedimento: {
                        contrato: {
                            unidade: {
                                nome: ""
                            }
                        },
                        procedimento: {
                            nome: ""
                        }
                    },
                    contrato_procedimento_atendimento: {
                        profissional: {
                            nome: ""
                        }
                    }
                }
            ],
            paciente_id: "",
            profissional: "",
            profissional_solicitante_id: "",
            situacao: "",
            solicitacao_historicos: [],
            diagnosticos: [],
            updated_at: "",
            usuario: "",
            usuario_solicitante_id: ""
        }
    }),
    mounted() {
        this.getSolicitacao();
    },
    updated() {
        window.print();
        window.close();
    },
    methods: {
        getSolicitacao() {
            this.$store.commit("TOGGLE_LOADING");
            axios
                .get(`${this.$store.state.serverURI}/api/atendimentos/boleto/${this.$route.params.solicitacaoId}`, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.solicitacao = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    watch: {},
    components: {
        solicitacaoBoleto
    }
};
</script>

<style>
@media print {
    * {
        font-size: 10px !important;
    }
    h4 {
        padding: 0;
        margin: 0;
    }
    .maior {
        font-size: 13px !important;
    }
    .codigo-maior {
        font-size: 18px !important;
    }
    .row {
        height: 0% !important;
    }
    p {
        line-height: 90%;
    }
    h1 {
        margin: 0 !important;
    }
    /* .container-fluid {
						margin-top: 30px;
					} */
    .vue-barcode-element {
        width: 200px !important;
        padding: 0px !important;
        margin: 0px !important;
        height: 60px !important;
    }
}
</style>



// WEBPACK FOOTER //
// impressaoBoleto.vue?46c06a50